import { useQuery } from "@tanstack/react-query"

import { FindProductLcasResponse } from "@tfg/types/schemas/modules/lifeCycleAnalysis/dtos/find-product-lcas.response.dto"
import { FindProductLcasRequestQueryParams } from "@tfg/types/schemas/modules/lifeCycleAnalysis/queries/find-product-lcas.request"

import { httpClient } from "~/backend/axios.ts"

export const useFindProductsLcasQuery = ({
  params,
}: {
  params: FindProductLcasRequestQueryParams
}) =>
  useQuery({
    queryKey: ["products", "lca", params],

    queryFn: async () => {
      const res = await httpClient.get<FindProductLcasResponse>(
        `/lca/find-product-lcas`,
        {
          params,
        }
      )
      return res.data
    },
  })
